module.exports = __webpack_public_path__ + "img/no-truck-available.abe5b1bd.svg";